import {STEPS} from "./constants";

import {moduleNamespace as productManagerModuleNamespace} from '../productManager/constants';
import {moduleNamespace as addonManagerModuleNamespace} from '../addonManager/constants';

export default {
  allSteps: () => STEPS,
  whitelabelStatus: ({customDomainStatus, customEmailStatus}) => {
    return {customDomainStatus, customEmailStatus};
  },
  whitelabelCustomDomainMessage: ({whitelabelCustomDomainMessage}) => whitelabelCustomDomainMessage,
  errors: ({errors}) => errors,
  currentStep: ({currentStep}) => currentStep,
  registration: ({registration}) => registration,
  whitelabelLogo: ({whitelabelLogo}) => whitelabelLogo,
  formFields: ({formFields}) => formFields,
  enableSupportAddon: (state, getters, rootState) => rootState[productManagerModuleNamespace].enableSupportAddon,
  softwareProduct: (state, getters, rootState) => rootState[productManagerModuleNamespace].softwareProduct,
  supportAddon: (state, getters, rootState) => rootState[productManagerModuleNamespace].supportAddon,
  addons: (state, getters, rootState) => rootState[addonManagerModuleNamespace].addons,
  taxConfig: ({taxConfig}) => taxConfig,
  chargingTax: ({taxConfig}) => taxConfig.charging,
  countries: ({countries}) => countries,
  loading: ({loading}) => loading,
  stripeAccountError: ({stripeAccountError}) => stripeAccountError,
};
